import type { Attachment } from '../types';

export const fetchAttachmentAsFile = async (file: Attachment) => {
  // CORS issue fix: https://natterco.atlassian.net/browse/N2-2766
  const response = await fetch(`${file.url}?${new Date().getTime()}`);
  const data = await response.blob();
  return new File([data], file.fileName, { type: file.contentType });
};
